//The add to cart form
let addToCartDiv = document.getElementById('add-to-cart');
//Pages that have multiple add to cart buttons
let addToCartCollection = document.querySelectorAll('.add-to-cart-collection');

//Listen for add to cart click, handle pages that dont have a add to cart button
if(addToCartDiv){
    addToCartDiv.addEventListener('click', function(event){
        event.preventDefault();
        //Get the course_id and domain_id from the hidden inputs in add to cart form
        let course_id = document.querySelector('.course-id').value;
        let domain_id = document.querySelector('.domain-id').value;
        //Make AJAX call
        buyNow(course_id, domain_id)
    });
}
//On pages with multiple add to cart buttons, loop through the nodelist, 
if(addToCartCollection){
    function addEvent(element){
        element.addEventListener('click', function(event){
            event.preventDefault();
            //Get the course_id and domain_id from the hidden inputs in add to cart div
            let course_id = element.querySelector('.course-id').value;
            let domain_id = element.querySelector('.domain-id').value;
             //Make AJAX call
            buyNow(course_id, domain_id);
        });
    }
        let i = 0;
        for( i = 0; i < addToCartCollection.length; i+=1 ){
            addEvent(addToCartCollection[i]);  
        }
}

//Add to cart Ajax Call
function addToCart(course_id, domain_id){
    axios.post('/cart/add', {
        data: {
            course_id: course_id,
            domain_id: domain_id
        },
        headers: {'Content-Type': 'application/json'}
    })
    .then(response => {
        //If success, update cart items UI element
        if(response.status === 200){
            updateCartItemsNumber(response.data.total);
            changeAddToCartButton(course_id);
        }
    })
} 

function updateCartItemsNumber(total){
    //The total items in cart UI element in nav bar
    let itemEl = document.querySelector('.cart-items-number');
    itemEl.textContent = total + (total > 1 ? ' Items' : ' Item');
}

//If an item is added to the cart, change the "add to cart" button to a "go to cart" link
function changeAddToCartButton(course_id){
    //The add to cart button for a specific product.
    let cartButtonElement = document.querySelector(`.add-cart-${course_id}`);
    let goToCartElement = document.querySelector(`.go-to-cart-${course_id}`);
    
    cartButtonElement.style.display = 'none';
    goToCartElement.style.display = 'block'; 
}

//Buy now Form
let buyNowDiv = document.getElementById('buy-now');

//Listen for buy now button click, handle pages that dont have a buy now button
if(buyNowDiv){
    buyNowDiv.addEventListener('click', function(event){
        event.preventDefault();
        //Get the course_id and domain_id from the hidden inputs in add to cart form
        let course_id = document.querySelector('.course-id').value;
        let domain_id = document.querySelector('.domain-id').value;
        //Make AJAX call
        buyNow(course_id, domain_id)
    });
} 

//Add to cart Ajax Call
function buyNow(course_id, domain_id){
    axios.post('/cart/add', {
        data: {
            course_id: course_id,
            domain_id: domain_id
        },
        headers: {'Content-Type': 'application/json'}
    })
    .then(response => {
        //If success, redirect to the chekcout page
        if(response.status === 200){
            window.location = '/checkout'
        }
    });
} 

